import React from 'react';
import Styles from './index.less';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import { STSchemeColorVal } from '@tencent/slide-sdk-model';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { ConnectorFastStyleType, IConnectorFastStyleConfig } from '@src/framework/workbench/ui/shape/shape-fast-style/fast-style-config';

export interface IShapeFastStyleCardProps {
    onClick: (style) => void;
    text: string;
    shapeStyles: IConnectorFastStyleConfig;
    slideModel: ISlideModel;
}

export default class ConnectorFastStyleCard extends React.PureComponent<IShapeFastStyleCardProps> {
    public render() {
        const { text, shapeStyles } = this.props;
        return (
            <Tooltip title={text} trigger="hover" placement={'top'} overlayHoverable={false}>
                <div
                    className={Styles['shape-fast-style-card']}
                    onClick={this.handleClick}
                >
                    <div className={Styles['connector-fast-style-card-icon-wrapper']}>
                        {this.getIcon(shapeStyles)}
                    </div>
                </div>
            </Tooltip>
        );
    }

    private handleClick = () => {
        this.props.onClick(this.props.shapeStyles);
    };

    private getIcon = (shapeStyles: IConnectorFastStyleConfig) => {
        const colorVal = shapeStyles.style?.border?.tdColor?.colorValue
            || shapeStyles.fastStyle?.lnRef?.egColorChoice?.schemeClr?.val || STSchemeColorVal.accent1;
        const color = `#${this.props.slideModel.getRelationThemeModel().clrScheme?.[colorVal]}`;
        switch (shapeStyles.type) {
            case ConnectorFastStyleType.subtle:
                return (
                    <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <line x1="5.91416" y1="6.19456" x2="34.096" y2="34.3764" stroke={color} strokeWidth="1.3"/>
                    </svg>
                );
            case ConnectorFastStyleType.moderate:
                return (
                    <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <line x1="6.16165" y1="5.94707" x2="34.3435" y2="34.1289" stroke={color} strokeWidth="2"/>
                    </svg>
                );
            case ConnectorFastStyleType.intense:
                return (
                    <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <line x1="6.44449" y1="5.66423" x2="34.6263" y2="33.846" stroke={color} strokeWidth="2.8"/>
                    </svg>
                );
            case ConnectorFastStyleType.dash:
                return (
                    <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <line x1="6.16165" y1="5.94707" x2="34.3435" y2="34.1289" stroke={color} strokeWidth="2" strokeDasharray="12.73 6.36"/>
                    </svg>
                );
            case ConnectorFastStyleType.singleArrow:
                return (
                    <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path style={{ fill: color }} d="M6.16165 5.03798C5.77113 4.64746 5.13796 4.64746 4.74744 5.03798C4.35691 5.4285 4.35691 6.06167 4.74744 6.45219L6.16165 5.03798ZM4.74744 6.45219L32.9293 34.634L34.3435 33.2198L6.16165 5.03798L4.74744 6.45219Z"/>
                        <path style={{ stroke: color }} d="M30.9091 23.9269L33.6364 33.9269" strokeWidth="2" strokeLinecap="round"/>
                        <path style={{ stroke: color }} d="M33.6364 33.9269L23.6837 31.0318" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                );
            case ConnectorFastStyleType.doubleArrow:
                return (
                    <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path style={{ fill: color }} d="M6.16165 5.03796C5.77113 4.64744 5.13796 4.64744 4.74744 5.03796C4.35691 5.42849 4.35691 6.06165 4.74744 6.45218L6.16165 5.03796ZM4.74744 6.45218L32.9293 34.634L34.3435 33.2198L6.16165 5.03796L4.74744 6.45218Z"/>
                        <path style={{ stroke: color }} d="M30.9091 23.9269L33.6364 33.9269" strokeWidth="2" strokeLinecap="round"/>
                        <path style={{ stroke: color }} d="M33.6364 33.9269L23.6837 31.0318" strokeWidth="2" strokeLinecap="round"/>
                        <path style={{ stroke: color }} d="M8.11369 15.7048L5.44204 5.68977" strokeWidth="2" strokeLinecap="round"/>
                        <path style={{ stroke: color }} d="M5.46687 5.6626L15.4033 8.61293" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                );
            default:
                return (
                    <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <line x1="5.91416" y1="6.19456" x2="34.096" y2="34.3764" stroke={color} strokeWidth="1.3"/>
                    </svg>
                );
        }
    };
}
